export const dispatchUndonePlacements = (
  dispatch,
  placements,
  selectedArr,
  undoArray
) => {
  dispatch({
    type: "UPDATE_COMPLETE_PLACEMENTS",
    completePlacements: [
      ...placements.filter((p) => {
        for (var i in selectedArr) {
          if (p.timesheet) {
            if (parseInt(undoArray[i].id) === p.timesheet.id) {
              return false;
            }
          }
        }
        return true;
      }),
    ],
  });
};
